import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import './i18n';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { preloadDojoGalleryImages } from "./helpers/dojoGalleryCache";

const root = ReactDOM.createRoot(document.getElementById('root'));
const queryClient = new QueryClient();

// Begin fetching dojo photos during initial application startup, before navigation.
preloadDojoGalleryImages().catch((error) => console.error("Failed to preload dojo gallery:", error));

root.render(
  <BrowserRouter>
    <QueryClientProvider client={queryClient}>
        <App />
    </QueryClientProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

